import { render, staticRenderFns } from "./TelemedicineHistoryForm.vue?vue&type=template&id=183347e0&scoped=true&"
import script from "./TelemedicineHistoryForm.vue?vue&type=script&lang=js&"
export * from "./TelemedicineHistoryForm.vue?vue&type=script&lang=js&"
import style0 from "./TelemedicineHistoryForm.vue?vue&type=style&index=0&id=183347e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183347e0",
  null
  
)

export default component.exports